
export default {
    getCategorias(state) {
        return state.categorias
    },
    getCategoria(state) {
        return state.categoria
    },
}